module.exports = __webpack_public_path__ + "static/media/avatars_male_25.0b667517.png";